import React from 'react';
import { DialogTitle } from '@mui/material';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { StyledDialog } from './index.style';
import { StyledIconButton } from '../TTSNew/Requests/index.style';

const DialogDictionary = ({
  title,
  open,
  width,
  maxWidth,
  children,
  onClose,
  fullWidth = true,
  borderRadius = '5px',
  titleFontSize = '20px',
  titleFontWeight = '600',
}) => (
  <StyledDialog
    fullWidth={fullWidth}
    width={width}
    maxWidth={maxWidth}
    open={open}
    onClose={onClose}
    borderRadius={borderRadius}
    titleFontSize={titleFontSize}
    titleFontWeight={titleFontWeight}
  >
    <DialogTitle left classes={{ root: 'dialog-title' }}>
      {title}
      <StyledIconButton
        disabled={false}
        height="40px"
        width="40px"
        borderRadius="50%"
        onClick={onClose}
        isDisableHover
        hiddenBorder
        padding="12px"
      >
        <CloseRoundedIcon color="secondary" />
      </StyledIconButton>
    </DialogTitle>
    {children}
  </StyledDialog>
);

export default DialogDictionary;
